<template>
  <div :class="recommendations.length > 0 ? 'recommender-main' : ''">
    <!--
    <div v-if='recommendations.length > 0' class="recommender-prompt">
      <img class="recommender-icon" src='/img/PBC_logo.svg' />
      <h1 v-if='recommendations.length' class="recommender-prompt-text">What do you want this toy to do?</h1>
      <h1 v-else-if='false && components.length > 1 && !recommendations.length' class="recommender-prompt-text">Great start! Add more features to create exciting behaviours!</h1>
    </div>
    -->
    <recommendations :recommendations='recommendations' @click='addRecommendation' />
    <!--
    <pbc-button v-if='recommendations.length === 0' @click="add" class="add-feature-button m-2">
      <plus-circle class="mx-1"/>
      <span class="mr-2">Add Feature</span>
    </pbc-button>
    <div v-if='recommendations.length > 0 || components.length === 1' class="pbc-component-viewing flex w-full justify-center">
      <pbc-button v-if='justAdded' @click="preview" class="m-2 pbc-primary-color ">
        <play class="mx-1"/>
        <span class="mr-2">Preview</span>
      </pbc-button>
    </div>
    -->
  </div>
</template>
<script>
import PlusCircle from '@icons/PlusCircle.vue';
import Play from '@icons/Play.vue';
import Recommender from '@edit/tree/recommender.js';
import Recommendations from '@/ui/molecules/Recommendations.vue';
export default {
  props: {
    gamedata: {
      type: Object,
      required: true
    },
    partutil: {
      type: Object,
      required: true
    },
    component: {
      type: Object,
      required: true
    },
    transform: {
      type: Object,
      required: true
    }
  },
  data() {
    const recommender = new Recommender(this.partutil, this.gamedata);
    const recommendations = [];
    const components = [];
    return {
      recommendations,
      recommender,
      components,
      justAdded: false
    }
  },
  components: {
    Recommendations,
    //Play,
    //PlusCircle
  },
  methods: {
    add() {
      this.$emit('add', {component:this.component});
    },
    addRecommendation(recommendation) {
      const {addedComponents, addedLinks} = this.recommender.addRecommendationTo(recommendation, this.transform, this.component);
      this.justAdded = true;
      this.$emit('add-recommendation', {
        addedComponents,
        addedLinks
      });
    },
    preview() {
      this.$emit('preview');
    }
  },
  watch:{
    component: {
      handler() {
        const {components,links} = this.partutil.findComponentsAndLinksFrom(this.component);
        this.components = components;
      },
      immediate: true
    },
    'partutil.from.components.length':{
      handler() {
        this.recommendations = this.recommender.getRecommendations(this.transform, this.component);
        const {components,links} = this.partutil.findComponentsAndLinksFrom(this.component);
        this.components = components;
      },
      immediate:true
    },
    'partutil.from.links.length'() {
        this.recommendations = this.recommender.getRecommendations(this.transform, this.component);
        const {components,links} = this.partutil.findComponentsAndLinksFrom(this.component);
        this.components = components;
    }
  }
}
</script>
